import styled from 'styled-components';

export const WrapperBottomIntend = styled.div`
  margin-bottom: 20px;
`;
